export default __webpack_public_path__ + "static/media/tw.8c1c8a3c.svg";